'use client';

import LocationIcon from '@/fo/icons/base/doctor/location.svg';
import { utilEventCityModal } from '@/fo/util/event-city-modal';

import { styles } from './UiDoctorSelectorCity.styles';

export interface UiDoctorSelectorCityProps {
  city: string;
  size?: 'xs' | 's';
  className?: string;
}

export function UiDoctorSelectorCity({
  city,
  size = 's',
  className
}: UiDoctorSelectorCityProps) {
  const slots = styles({ size });

  return (
    <button
      className={slots.base({ className })}
      type="button"
      onClick={() => utilEventCityModal.open()}
    >
      <LocationIcon />
      {city}
    </button>
  );
}
